__turbopack_context__.v({
  "bar": "Fq1Fca_bar",
  "icon": "Fq1Fca_icon",
});
